import React, { useEffect } from 'react'
import LoadingLogoPage from '../loadingPage/loadingPage'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

function AddRedirectInfo() {

  const location = useLocation();


  const currentPath = location.pathname ? location.pathname.replace(/^\//, "") : ""

  if (currentPath) {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("redirectUrl", currentPath);
    return <Navigate to={`/?${queryParams.toString()}`} replace={true} />
  } else {

    return <Navigate to={`/`} replace={true} />
  }




}

export default AddRedirectInfo